import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useDispatch } from 'react-redux';
import { createRequestTypes, INVITE_PROFESSIONALS_TO_JOBS } from '~/actions';
import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';

interface IInviteProfessionalsToJobsPayload {
  jobIds: string[];
  professionalIds: string[];
  officeId?: string;
}

const inviteProfessionalsEvents = createRequestTypes(INVITE_PROFESSIONALS_TO_JOBS) as {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
};

export function useInviteProfessionalsToJobsMutation() {
  const dispatch = useDispatch();

  return useMutation<unknown, AxiosError, IInviteProfessionalsToJobsPayload>({
    mutationFn: async ({ jobIds, professionalIds, officeId }) => {
      return await apiMethods[apiMethodsConst.INVITE_PROFESSIONALS_TO_JOBS_REQUEST]({
        jobIds,
        professionalIds,
        officeId,
      });
    },
    onMutate: () => {
      dispatch({ type: inviteProfessionalsEvents.REQUEST });
    },
    onSuccess: () => {
      dispatch({ type: inviteProfessionalsEvents.SUCCESS });
    },
    onError: (error) => {
      dispatch({
        type: inviteProfessionalsEvents.FAILURE,
        payload: error.response?.data ?? error,
      });
    },
  });
}
